import validationGeneral from '@/services/general/validation/validationRetourEdition';

export default function validationEdition(response, messages) {
  response.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('EDITION_IMPRESSION_NOT_ENSEIGNE') !== -1) {
      messages.push({
        message: 'editionDemandeImpression.validation.edition.notEnseigne',
      });
    }
  });
  validationGeneral(response, messages);
}
